import { render, staticRenderFns } from "./addCYS.vue?vue&type=template&id=252f0c59&scoped=true&"
import script from "./addCYS.vue?vue&type=script&lang=js&"
export * from "./addCYS.vue?vue&type=script&lang=js&"
import style0 from "./addCYS.vue?vue&type=style&index=0&id=252f0c59&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252f0c59",
  null
  
)

export default component.exports